namespace GeniuzPOS.Inventory {
    export interface IcStockAdjustOutRow {
        Id?: number;
        SysDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        StkAdjCode?: string;
        StkAdjcodeName?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        StockTo?: string;
        WhsId?: string;
        WhsName?: string;
        Remark?: string;
        PostFg?: PostFgStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        AdjustOutDtList?: IcStockAdjustOutDtRow[];
        CancelFg?: CancelFgstatus;
        AdjFg?: number;
    }

    export namespace IcStockAdjustOutRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockAdjustOut';
        export const lookupKey = 'Inventory.IcStockAdjustOut';

        export function getLookup(): Q.Lookup<IcStockAdjustOutRow> {
            return Q.getLookup<IcStockAdjustOutRow>('Inventory.IcStockAdjustOut');
        }
        export const deletePermission = '2Inventory:รายการ:ปรับปรุง:Modify';
        export const insertPermission = '2Inventory:รายการ:ปรับปรุง:Modify';
        export const readPermission = '2Inventory:รายการ:ปรับปรุง:View';
        export const updatePermission = '2Inventory:รายการ:ปรับปรุง:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            StkAdjCode = "StkAdjCode",
            StkAdjcodeName = "StkAdjcodeName",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            StockTo = "StockTo",
            WhsId = "WhsId",
            WhsName = "WhsName",
            Remark = "Remark",
            PostFg = "PostFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            AdjustOutDtList = "AdjustOutDtList",
            CancelFg = "CancelFg",
            AdjFg = "AdjFg"
        }
    }
}
